<section class="content">
    <div class="form-group">
        <label class="font-weight-bold">{{ 'activity' | localise }}</label>

        <div class="form-check" *ngFor="let item of activities">
            <label class="form-check-label">
                <input type="radio"
                       class="form-check-input"
                       name="activity"
                       id="activity{{ item.id }}"
                       value="{{ item.id}}"
                       (input)="onActivitySelected(item)"
                       [checked]="currentlySelectedActivity?.id == item.id"/>
                {{ item.title }}
                <i class="input-helper"></i>
            </label>
        </div>
    </div>

    <div class="form-group">
        <label class="font-weight-bold">{{ 'weekly_trainings' | localise }}</label>

        <div class="row training-row" *ngFor="let training of trainings; let i = index">
            <div class="col-sm-4 col-md-4 training-day">
                <button class="btn btn-sm btn-danger" (click)="removeTraining(i)"><i class="ti-close"></i></button>
                <button class="btn btn-sm btn-primary" (click)="duplicateTraining(i)"><i class="fa fa-copy"></i></button>

                <select required="required" (change)="onDayChange($event, i)" class="form-control">
                    <option value="">{{ 'DAY' | localise }}</option>
                    <option
                            [selected]="training.day && 'MON' === training.day"
                            value="MON">{{'monday' | localise}}
                    </option>
                    <option
                            [selected]="training.day && 'TUE' === training.day"
                            value="TUE">{{'tuesday' | localise}}
                    </option>
                    <option
                            [selected]="training.day && 'WED' === training.day"
                            value="WED">{{'wednesday' | localise}}
                    </option>
                    <option
                            [selected]="training.day && 'THU' === training.day"
                            value="THU">{{'thursday' | localise}}
                    </option>
                    <option
                            [selected]="training.day && 'FRI' === training.day"
                            value="FRI">{{'friday' | localise}}
                    </option>
                    <option
                            [selected]="training.day && 'SAT' === training.day"
                            value="SAT">{{'saturday' | localise}}
                    </option>
                    <option
                            [selected]="training.day && 'SUN' === training.day"
                            value="SUN">{{'sunday' | localise}}
                    </option>
                </select>
            </div>
            <div class="col-sm-4 col-md-4">
                <select (change)="onTrainingChange($event, i)" class="form-control">
                    <option value="">{{ 'TRAINING' | localise }}</option>
                    <option
                            *ngFor="let item of trainingActivities"
                            [selected]="training.training_activity && item.id === training.training_activity.id"
                            [value]="item.id">
                        {{ item.title }}
                    </option>
                </select>
            </div>
            <div class="col-sm-4 col-md-4">
                <select (change)="onDurationChange($event, i)" class="form-control">
                    <option value="">{{ 'DURATION' | localise }}</option>
                    <option
                            *ngFor="let item of trainingDurations"
                            [selected]="training.training_duration && item.id === training.training_duration.id"
                            [value]="item.id">
                        {{ item.duration | minutesToReadableTime }} ({{ 'active_part' | localise }})
                    </option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-3 col-xs-12">
                <button (click)="addTraining()" class="btn btn-sm btn-success add-new-training">
                    <i class="ti-plus"></i>
                    {{ 'add_new_training' | localise }}
                </button>
            </div>
        </div>
    </div>

    <div class="mt-4" *ngIf="editable">
        <button class="btn btn-block btn-primary" (click)="updateProfile()">{{'save' | localise}}</button>
    </div>
</section>
